export const builds = [
    // Anarchist
    {
        "name": "Anarchist",
        "keySpecies": ['Quexi', "Ts'tsen"],
        "keyExpertise": ['Hacker', 'Chemist', 'Operative'],
        "keyAttrs": ['INT', 'WIS'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Botanist', 'Sprinter', 'Dual-Wielder', 'Warder', 'Fire', 'Operative', 'Chemist', 'Flood', 'Skyrunner', 'Sniper', 'Hustler', 'Perception', 'Gunslinger', 'Mentalist', 'Hacker', 'Martial Artist', 'Driver', 'Light'],
        "description": "They hide in plain sight and sabotage the plans of those in power. They rely on crafting drones and explosives for combat, and influence the world around them as masters of diguise.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 7
                    },
                    {
                        "attr": "DEX",
                        "inc": 10
                    },
                    {
                        "attr": "CON",
                        "inc": 8
                    },
                    {
                        "attr": "INT",
                        "inc": 14
                    },
                    {
                        "attr": "WIS",
                        "inc": 13
                    },
                    {
                        "attr": "CHA",
                        "inc": 10
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 1
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 1
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 1
                    },
                    {
                        "skill": 'Observation',
                        "inc": 2
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 4
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 1
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 2
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 2
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 1
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 8
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 1
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 1
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Assassin
    {
        "name": "Assassin",
        "keySpecies": ["Ts'tsen", "Aerzha"],
        "keyExpertise": ['Thief', 'Sniper', 'Light'],
        "keyAttrs": ['DEX', 'INT'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Botanist', 'Sprinter', 'Fencer', 'Warder', 'Fire', 'Thief', 'Pyromaniac', 'Flood', 'Skyrunner', 'Sniper', 'Hustler', 'Perception', 'Gunslinger', 'Mentalist', 'Hacker', 'Martial Artist', 'Driver', 'Light'],
        "description": "Move through shadows to get the perfect vantage point and strike hard. They have other means of getting the job done should the usual method prove unsuccessful.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 8
                    },
                    {
                        "attr": "DEX",
                        "inc": 14
                    },
                    {
                        "attr": "CON",
                        "inc": 7
                    },
                    {
                        "attr": "INT",
                        "inc": 10
                    },
                    {
                        "attr": "WIS",
                        "inc": 13
                    },
                    {
                        "attr": "CHA",
                        "inc": 10
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 2
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 1
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 2
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 4
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 1
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 3
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 2
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Commando
    {
        "name": "Commando",
        "keySpecies": ["Muhmin", "Koz'aid"],
        "keyExpertise": ['Heavy Armor', 'Special Ops', 'Bodybuilder'],
        "keyAttrs": ['CON', 'STR'],
        "expertiseList": ['Heavy Armor', 'Special Ops', 'Botanist', 'Bodybuilder', 'Dual-Wielder', 'Bruiser', 'Fire', 'Operative', 'Chemist', 'Flood', 'Skyrunner', 'Sniper', 'Hustler', 'Perception', 'Duelist', 'Healer', 'Hacker', 'Martial Artist', 'Driver', 'Light'],
        "description": "The optimal front-line soldier. They tend to run into situations guns ablaze, but it's ok because they have the armor and health to take it.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 14
                    },
                    {
                        "attr": "DEX",
                        "inc": 8
                    },
                    {
                        "attr": "CON",
                        "inc": 13
                    },
                    {
                        "attr": "INT",
                        "inc": 10
                    },
                    {
                        "attr": "WIS",
                        "inc": 10
                    },
                    {
                        "attr": "CHA",
                        "inc": 7
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Dark Detective
    {
        "name": "Dark Detective",
        "keySpecies": ["Quexi", "Aerzha"],
        "keyExpertise": ['Brawler', 'Insight', 'Hacker'],
        "keyAttrs": ['INT', 'STR'],
        "expertiseList": ['Heavy Armor', 'Special Ops', 'Botanist', 'Bodybuilder', 'Dual-Wielder', 'Bruiser', 'Fire', 'Operative', 'Chemist', 'Flood', 'Singularity', 'Sniper', 'Charmer', 'Insight', 'Gunslinger', 'Healer', 'Hacker', 'Brawler', 'Driver', 'Light'],
        "description": "A highly intelligent investigator who brings bad guys to justice through the use of their fists and gadgets. Maybe they prefer to work at night? And maybe they hold a grudge after the murder of their parents?",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 13
                    },
                    {
                        "attr": "DEX",
                        "inc": 7
                    },
                    {
                        "attr": "CON",
                        "inc": 10
                    },
                    {
                        "attr": "INT",
                        "inc": 14
                    },
                    {
                        "attr": "WIS",
                        "inc": 10
                    },
                    {
                        "attr": "CHA",
                        "inc": 8
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Desperado
    {
        "name": "Desperado",
        "keySpecies": ["Quexi", "Veith"],
        "keyExpertise": ['Duelist', 'Fire', 'Perception'],
        "keyAttrs": ['WIS', 'DEX'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Botanist', 'Sprinter', 'Dual-Wielder', 'Warder', 'Fire', 'Thief', 'Pyromaniac', 'Ice', 'Skyrunner', 'Ranger', 'Hustler', 'Perception', 'Duelist', 'Healer', 'Hacker', 'Martial Artist', 'Pilot', 'Light'],
        "description": "A wily stranger who drifted into town. They shoot first and ask questions later. Should a gun prove to be ineffective, they can also harness the power of flames.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 10
                    },
                    {
                        "attr": "DEX",
                        "inc": 13
                    },
                    {
                        "attr": "CON",
                        "inc": 8
                    },
                    {
                        "attr": "INT",
                        "inc": 10
                    },
                    {
                        "attr": "WIS",
                        "inc": 14
                    },
                    {
                        "attr": "CHA",
                        "inc": 7
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Doctor
    {
        "name": "Doctor",
        "keySpecies": ["Aerzha", "Veith"],
        "keyExpertise": ['Charmer', 'Healer', 'Pilot'],
        "keyAttrs": ['CHA', 'WIS'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Zoologist', 'Bodybuilder', 'Fencer', 'Bruiser', 'Lightning', 'Operative', 'Chemist', 'Ice', 'Skyrunner', 'Sniper', 'Charmer', 'Insight', 'Duelist', 'Healer', 'Hacker', 'Martial Artist', 'Pilot', 'Sound'],
        "description": "Friendly and debonair, the Doctor always seems to be at the right place at the right time. They prefer to win with words, but will certainly fight for what is right and to protect their companions.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 6
                    },
                    {
                        "attr": "DEX",
                        "inc": 6
                    },
                    {
                        "attr": "CON",
                        "inc": 10
                    },
                    {
                        "attr": "INT",
                        "inc": 12
                    },
                    {
                        "attr": "WIS",
                        "inc": 14
                    },
                    {
                        "attr": "CHA",
                        "inc": 14
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Dragon
    {
        "name": "Dragon",
        "keySpecies": ["Muhmin", "Ts'tsen"],
        "keyExpertise": ['Martial Artist', 'Sprinter', 'Light Armor'],
        "keyAttrs": ['DEX', 'STR'],
        "expertiseList": ['Light Armor', 'Bullet Hell', 'Botanist', 'Sprinter', 'Dual Wielder', 'Bruiser', 'Fire', 'Thief', 'Pyromaniac', 'Flood', 'Skyrunner', 'Ranger', 'Hustler', 'Perception', 'Duelist', 'Healer', 'Hacker', 'Martial Artist', 'Pilot', 'Light'],
        "description": "Highly mobile and agile, they are a master at turning their body into a weapon. Besides, you can't kill what you can't touch.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 14
                    },
                    {
                        "attr": "DEX",
                        "inc": 14
                    },
                    {
                        "attr": "CON",
                        "inc": 10
                    },
                    {
                        "attr": "INT",
                        "inc": 6
                    },
                    {
                        "attr": "WIS",
                        "inc": 10
                    },
                    {
                        "attr": "CHA",
                        "inc": 8
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Duke
    {
        "name": "Duke",
        "keySpecies": ["Aerzha", "Quexi"],
        "keyExpertise": ['Insight', 'Fencer', 'Mentalist'],
        "keyAttrs": ['CHA', 'INT'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Zoologist', 'Sprinter', 'Fencer', 'Warder', 'Lightning', 'Operative', 'Chemist', 'Ice', 'Skyrunner', 'Sniper', 'Charmer', 'Insight', 'Gunsilnger', 'Mentalist', 'Hacker', 'Martial Artist', 'Pilot', 'Light'],
        "description": "Trained from birth to know the strength of mind and blade, they are destined to greatness. It's like they can see the future before it happens.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 6
                    },
                    {
                        "attr": "DEX",
                        "inc": 10
                    },
                    {
                        "attr": "CON",
                        "inc": 8
                    },
                    {
                        "attr": "INT",
                        "inc": 14
                    },
                    {
                        "attr": "WIS",
                        "inc": 10
                    },
                    {
                        "attr": "CHA",
                        "inc": 14
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            }
        ]
    },
    // Elemental
    {
        "name": "Elemental",
        "keySpecies": ["Veith", "Muhmin"],
        "keyExpertise": ['Fire', 'Flood', 'Skyrunner'],
        "keyAttrs": ['WIS', 'STR'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Botanist', 'Sprinter', 'Dual-Wielder', 'Bruiser', 'Fire', 'Operative', 'Pyromaniac', 'Flood', 'Skyrunner', 'Sniper', 'Hustler', 'Perception', 'Duelist', 'Healer', 'Hacker', 'Martial Artist', 'Driver', 'Light'],
        "description": "A master of manipulating the elements. They are fast and agile, needing no weapon except their own body and their stims.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 13
                    },
                    {
                        "attr": "DEX",
                        "inc": 10
                    },
                    {
                        "attr": "CON",
                        "inc": 7
                    },
                    {
                        "attr": "INT",
                        "inc": 10
                    },
                    {
                        "attr": "WIS",
                        "inc": 14
                    },
                    {
                        "attr": "CHA",
                        "inc": 8
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Enforcer
    {
        "name": "Enforcer",
        "keySpecies": ["Muhmin", "Koz'aid"],
        "keyExpertise": ['Bullet Hell', 'Bodybuilder', 'Bruiser'],
        "keyAttrs": ['CHA', 'INT'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Zoologist', 'Sprinter', 'Fencer', 'Warder', 'Lightning', 'Operative', 'Chemist', 'Ice', 'Skyrunner', 'Sniper', 'Charmer', 'Insight', 'Gunsilnger', 'Mentalist', 'Hacker', 'Martial Artist', 'Pilot', 'Light'],
        "description": "They're good at hurting people, even if they get hurt in the process. Not sure what to do when not fighting.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 16
                    },
                    {
                        "attr": "DEX",
                        "inc": 8
                    },
                    {
                        "attr": "CON",
                        "inc": 16
                    },
                    {
                        "attr": "INT",
                        "inc": 10
                    },
                    {
                        "attr": "WIS",
                        "inc": 6
                    },
                    {
                        "attr": "CHA",
                        "inc": 6
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Enigma
    {
        "name": "Enigma",
        "keySpecies": ["Veith", "Quexi"],
        "keyExpertise": ['Light', 'Hustler', 'Botanist'],
        "keyAttrs": ['WIS', 'INT'],
        "expertiseList": ['Light Armor', 'Bullet Hell', 'Botanist', 'Sprinter', 'Fencer', 'Warder', 'Lightning', 'Thief', 'Chemist', 'Ice', 'Skyrunner', 'Sniper', 'Hustler', 'Perception', 'Duelist', 'Mentalist', 'Tinkerer', 'Martial Artist', 'Pilot', 'Light'],
        "description": "Illusions, lies, and strange concoctions. They make everyone around them question the very fabric of reality.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 6
                    },
                    {
                        "attr": "DEX",
                        "inc": 10
                    },
                    {
                        "attr": "CON",
                        "inc": 10
                    },
                    {
                        "attr": "INT",
                        "inc": 12
                    },
                    {
                        "attr": "WIS",
                        "inc": 14
                    },
                    {
                        "attr": "CHA",
                        "inc": 10
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Explorer
    {
        "name": "Explorer",
        "keySpecies": ["Quexi", "Aerzha"],
        "keyExpertise": ['Ranger', 'Zoologist', 'Perception'],
        "keyAttrs": ['INT', 'CHA'],
        "expertiseList": ['Light Armor', 'Bullet Hell', 'Zoologist', 'Sprinter', 'Fencer', 'Warder', 'Lightning', 'Thief', 'Chemist', 'Ice', 'Skyrunner', 'Ranger', 'Charmer', 'Insight', 'Gunslinger', 'Mentalist', 'Tinkerer', 'Martial Artist', 'Pilot', 'Light'],
        "description": "In constant search for adventure, they are driven by the thrill of the hunt. They always have their trusty pets by their side.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 8
                    },
                    {
                        "attr": "DEX",
                        "inc": 10
                    },
                    {
                        "attr": "CON",
                        "inc": 8
                    },
                    {
                        "attr": "INT",
                        "inc": 14
                    },
                    {
                        "attr": "WIS",
                        "inc": 8
                    },
                    {
                        "attr": "CHA",
                        "inc": 14
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            }
        ]
    },
    // Hoarder
    {
        "name": "Hoarder",
        "keySpecies": ["Koz'aid", "Quexi"],
        "keyExpertise": ['Botanist', 'Tinkerer', 'Chemist'],
        "keyAttrs": ['INT', 'CON'],
        "expertiseList": ['Heavy Armor', 'Special Ops', 'Botanist', 'Sprinter', 'Dual-Wielder', 'Warder', 'Lightning', 'Operative', 'Chemist', 'Ice', 'Skyrunner', 'Sniper', 'Charmer', 'Perception', 'Gunslinger', 'Mentalist', 'Tinkerer', 'Brawler', 'Driver', 'Sound'],
        "description": "Collects all the things. Do not select this build if you don't enjoy resource management and crafting!!!",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 6
                    },
                    {
                        "attr": "DEX",
                        "inc": 8
                    },
                    {
                        "attr": "CON",
                        "inc": 16
                    },
                    {
                        "attr": "INT",
                        "inc": 16
                    },
                    {
                        "attr": "WIS",
                        "inc": 10
                    },
                    {
                        "attr": "CHA",
                        "inc": 6
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Machinist
    {
        "name": "Machinist",
        "keySpecies": ["Koz'aid", "Quexi"],
        "keyExpertise": ['Pyromaniac', 'Tinkerer', 'Driver'],
        "keyAttrs": ['CON', 'STR'],
        "expertiseList": ['Heavy Armor', 'Bullet Hell', 'Botany', 'Bodybuilder', 'Dual-Wielder', 'Bruiser', 'Lightning', 'Operative', 'Pyromaniac', 'Ice', 'Singularity', 'Ranger', 'Charmer', 'Perception', 'Gunslinger', 'Healer', 'Tinkerer', 'Brawler', 'Driver', 'Sound'],
        "description": "They feel most at home getting their hands dirty in a workshop. You'll usually find them collecting materials and crafting them into grenades, mods, or robots. They also like to tinker with land vehicles, because who doesn't like a rocket launcher on a mech suit?",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 14
                    },
                    {
                        "attr": "DEX",
                        "inc": 10
                    },
                    {
                        "attr": "CON",
                        "inc": 14
                    },
                    {
                        "attr": "INT",
                        "inc": 10
                    },
                    {
                        "attr": "WIS",
                        "inc": 6
                    },
                    {
                        "attr": "CHA",
                        "inc": 8
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 2
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 5
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Maverick
    {
        "name": "Maverick",
        "keySpecies": ["Ts'tsen", "Veith"],
        "keyExpertise": ['Pilot', 'Gunslinger', 'Operative'],
        "keyAttrs": ['INT', 'CON'],
        "expertiseList": ['Light Armor', 'Bullet Hell', 'Zoologist', 'Sprinter', 'Fencer', 'Warder', 'Lightning', 'Operative', 'Chemist', 'Ice', 'Skyrunner', 'Sniper', 'Hustler', 'Insight', 'Gunslinger', 'Mentalist', 'Tinkerer', 'Martial Artist', 'Pilot', 'Light'],
        "description": "The sly and charismatic pilot. They seem to always find themselves in a bit of mischief, but at least they're more than capable of shooting their way out of a mess.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 8
                    },
                    {
                        "attr": "DEX",
                        "inc": 14
                    },
                    {
                        "attr": "CON",
                        "inc": 8
                    },
                    {
                        "attr": "INT",
                        "inc": 8
                    },
                    {
                        "attr": "WIS",
                        "inc": 10
                    },
                    {
                        "attr": "CHA",
                        "inc": 14
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 5
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            }
        ]
    },
    // Savior
    {
        "name": "Savior",
        "keySpecies": ["Aerzha", "Koz'aid"],
        "keyExpertise": ['Healer', 'Ice', 'Sound'],
        "keyAttrs": ['CON', 'WIS'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Zoologist', 'Sprinter', 'Fencer', 'Warder', 'Lightning', 'Operative', 'Chemist', 'Ice', 'Singularity', 'Sniper', 'Charmer', 'Insight', 'Duelist', 'Healer', 'Tinkerer', 'Brawler', 'Pilot', 'Sound'],
        "description": "Their main focus is to help out their teammates. They are everybody's best friend.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 6
                    },
                    {
                        "attr": "DEX",
                        "inc": 6
                    },
                    {
                        "attr": "CON",
                        "inc": 14
                    },
                    {
                        "attr": "INT",
                        "inc": 10
                    },
                    {
                        "attr": "WIS",
                        "inc": 14
                    },
                    {
                        "attr": "CHA",
                        "inc": 12
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 5
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Shogun
    {
        "name": "Shogun",
        "keySpecies": ["Aerzha", "Muhmin"],
        "keyExpertise": ['Dual-Wielder', 'Singularity', 'Mentalist'],
        "keyAttrs": ['CON', 'WIS'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Zoologist', 'Sprinter', 'Dual-Wielder', 'Warder', 'Lightning', 'Thief', 'Pyromaniac', 'Flood', 'Singularity', 'Ranger', 'Hustler', 'Perception', 'Duelist', 'Mentalist', 'Hacker', 'Martial Artist', 'Pilot', 'Light'],
        "description": "A mystical figure who is master of mind and blade. They hold tight to their traditions as they focus on connecting to the force of the universe.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 10
                    },
                    {
                        "attr": "DEX",
                        "inc": 14
                    },
                    {
                        "attr": "CON",
                        "inc": 6
                    },
                    {
                        "attr": "INT",
                        "inc": 10
                    },
                    {
                        "attr": "WIS",
                        "inc": 12
                    },
                    {
                        "attr": "CHA",
                        "inc": 10
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 5
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Stalwart
    {
        "name": "Stalwart",
        "keySpecies": ["Koz'aid", "Muhmin"],
        "keyExpertise": ['Warder', 'Ice', 'Heavy Armor'],
        "keyAttrs": ['CON', 'STR'],
        "expertiseList": ['Heavy Armor', 'Special Ops', 'Botanist', 'Bodybuilder', 'Dual-Wielder', 'Warder', 'Lightning', 'Operative', 'Chemist', 'Ice', 'Singularity', 'Sniper', 'Hustler', 'Perception', 'Duelist', 'Mentalist', 'Hacker', 'Martial Artist', 'Pilot', 'Light'],
        "description": "Through a combination of armor and sheer might, they will shrug off most incoming damage. They are a veritable walking brick wall, or at least a walking ice wall.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 14
                    },
                    {
                        "attr": "DEX",
                        "inc": 6
                    },
                    {
                        "attr": "CON",
                        "inc": 16
                    },
                    {
                        "attr": "INT",
                        "inc": 6
                    },
                    {
                        "attr": "WIS",
                        "inc": 12
                    },
                    {
                        "attr": "CHA",
                        "inc": 8
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 5
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 5
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 5
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 5
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 5
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 1
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Stormrunner
    {
        "name": "Stormrunner",
        "keySpecies": ["Veith", "Muhmin"],
        "keyExpertise": ['Lightning', 'Skyrunner', 'Martial Artist'],
        "keyAttrs": ['DEX', 'WIS'],
        "expertiseList": ['Light Armor', 'Bullet Hell', 'Botanist', 'Sprinter', 'Dual-Wielder', 'Bruiser', 'Lightning', 'Thief', 'Pyromaniac', 'Flood', 'Skyrunner', 'Ranger', 'Hustler', 'Perception', 'Duelist', 'Healer', 'Hacker', 'Martial Artist', 'Pilot', 'Light'],
        "description": "Shockingly mobile and dishing out both ranged and melee damage, it's like they were blessed by the storms.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 12
                    },
                    {
                        "attr": "DEX",
                        "inc": 14
                    },
                    {
                        "attr": "CON",
                        "inc": 10
                    },
                    {
                        "attr": "INT",
                        "inc": 8
                    },
                    {
                        "attr": "WIS",
                        "inc": 12
                    },
                    {
                        "attr": "CHA",
                        "inc": 6
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 1
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 5
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 5
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 5
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            }
        ]
    },
    // Street Rat
    {
        "name": "Street Rat",
        "keySpecies": ["Ts'tsen", "Aerzha"],
        "keyExpertise": ['Hustler', 'Thief', 'Zoologist'],
        "keyAttrs": ['INT', 'CHA'],
        "expertiseList": ['Light Armor', 'Special Ops', 'Zoologist', 'Sprinter', 'Fencer', 'Warder', 'Lightning', 'Thief', 'Pyromaniac', 'Flood', 'Skyrunner', 'Ranger', 'Hustler', 'Perception', 'Duelist', 'Mentalist', 'Hacker', 'Martial Artist', 'Pilot', 'Light'],
        "description": "Having learned how to survive on their own in back alleys and slums, their best friends tend to be animals.",
        "levelBreakdown": [
            // Level 1
            {
                "levelNum": 1,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 6
                    },
                    {
                        "attr": "DEX",
                        "inc": 12
                    },
                    {
                        "attr": "CON",
                        "inc": 6
                    },
                    {
                        "attr": "INT",
                        "inc": 14
                    },
                    {
                        "attr": "WIS",
                        "inc": 10
                    },
                    {
                        "attr": "CHA",
                        "inc": 14
                    }
                ]
            },
            // Level 2
            {
                "levelNum": 2,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 5
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 3
            {
                "levelNum": 3,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 4
            {
                "levelNum": 4,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 1
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 5
            {
                "levelNum": 5,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 6
            {
                "levelNum": 6,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 7
            {
                "levelNum": 7,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 8
            {
                "levelNum": 8,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 1
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 9
            {
                "levelNum": 9,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 5
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 10
            {
                "levelNum": 10,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 11
            {
                "levelNum": 11,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 12
            {
                "levelNum": 12,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 1
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 13
            {
                "levelNum": 13,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 5
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 14
            {
                "levelNum": 14,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 15
            {
                "levelNum": 15,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 16
            {
                "levelNum": 16,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 17
            {
                "levelNum": 17,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            // Level 18
            {
                "levelNum": 18,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 5
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            },
            // Level 19
            {
                "levelNum": 19,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 0
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 5
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 5
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 0
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 0
                    }
                ]
            },
            //Level 20
            {
                "levelNum": 20,
                "skillIncs": [
                    {
                        "skill": 'Armor',
                        "inc": 0
                    },
                    {
                        "skill": 'Assault Weapons',
                        "inc": 0
                    },
                    {
                        "skill": 'Astrobiology',
                        "inc": 5
                    },
                    {
                        "skill": 'Athletics',
                        "inc": 0
                    },
                    {
                        "skill": 'Blade',
                        "inc": 0
                    },
                    {
                        "skill": 'Blunt',
                        "inc": 0
                    },
                    {
                        "skill": 'Energy',
                        "inc": 0
                    },
                    {
                        "skill": 'Espionage',
                        "inc": 0
                    },
                    {
                        "skill": 'Explosives',
                        "inc": 0
                    },
                    {
                        "skill": 'Fluid',
                        "inc": 0
                    },
                    {
                        "skill": 'Gravity',
                        "inc": 0
                    },
                    {
                        "skill": 'Long Range',
                        "inc": 5
                    },
                    {
                        "skill": 'Negotiation',
                        "inc": 0
                    },
                    {
                        "skill": 'Observation',
                        "inc": 0
                    },
                    {
                        "skill": 'Pistol',
                        "inc": 0
                    },
                    {
                        "skill": 'Psyche',
                        "inc": 0
                    },
                    {
                        "skill": 'Tech',
                        "inc": 0
                    },
                    {
                        "skill": 'Unarmed',
                        "inc": 0
                    },
                    {
                        "skill": 'Vehicles',
                        "inc": 0
                    },
                    {
                        "skill": 'Wave',
                        "inc": 0
                    }
                ],
                "attrIncs": [
                    {
                        "attr": "STR",
                        "inc": 0
                    },
                    {
                        "attr": "DEX",
                        "inc": 0
                    },
                    {
                        "attr": "CON",
                        "inc": 0
                    },
                    {
                        "attr": "INT",
                        "inc": 0
                    },
                    {
                        "attr": "WIS",
                        "inc": 0
                    },
                    {
                        "attr": "CHA",
                        "inc": 1
                    }
                ]
            }
        ]
    }
]